import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { ColorVar } from '../../../../../styles/variables'

export const useStyles = makeStyles((theme: Theme) => ({
  wrapper: {
    height: '100%',
    '& .mapWrapper': {
      width: '100%',
      height: '100%'
    },
    '& .mapContainer': {
      width: '100%',
      height: '100%',
      position: 'relative'
    },
    '& .mapWithBanner': {
      height: 'calc(100% - 54px)'
    },
    '& .exportBtn': {
      [theme.breakpoints.up('tablet')]: {
        width: '168px'
      }
    },
    '& .weeklyReport': {
      [theme.breakpoints.up('tablet')]: {
        width: '212px'
      }
    },
    '& .weeklyReport, & .exportBtn': {
      color: ColorVar.black,
      display: 'flex',
      flexDirection: 'row',
      [theme.breakpoints.up('tablet')]: {
        height: '48px'
      },
      textTransform: 'none',
      marginRight: '10px',
      borderRadius: '5px',
      background: '#fff',
      border: 'none',
      '& .reportImg': {
        width: '17px',
        marginRight: '10px'
      },
      '&:hover': {
        background: '#fff'
      }
    },
    '& .exportImg': {
      width: '22px',
      marginRight: '10px'
    },
    '& .MuiTypography-body1': {
      fontSize: '18px',
      fontWeight: 500,
      color: '#000'
    },
    '& .leaflet-top.leaflet-right': {
      display: 'flex',
      flexDirection: 'row-reverse'
    },
    '& .station-marker': {
      borderRadius: '50%',
      backgroundColor: '#cccccc',
      cursor: 'grab'
    }
  },
  playWeeklyContainer: {
    background: 'white',
    zIndex: 1000,
    position: 'absolute',
    bottom: 0,
    left: '30%',
    right: '10%',
    padding: '10px',
    [theme.breakpoints.between('mobile', 'tablet')]: {
      left: '35%',
      right: '20%'
    },
    [theme.breakpoints.between(0, 'mobile')]: {
      left: '50%',
      right: 'auto'
    }
  }
}))
